export const ROUTE_NAMESPACES = {
  ACCOUNT: '/account',
  CTA_COMMUNITIES: '/cta-communities',
  ANTIPIRACY: '/antipiracy',
  BROADCAST: '/broadcast',
  CLASS: '/classes',
  COMMUNITY: '/community',
  CONFIG: '/settings',
  LOGIN: '/login',
  MODULE: '/modules',
  EXTRA_PAID_MODULE: '/modules/extra-paid',
  TRACKS: '/tracks',
  REPORTS: '/reports',
  SALES: '/sales',
  FREE_SIGNUP: '/free-signup',
  USER: '/users',
  DASHBOARD: '/dashboard',
  DEFAULT: '/'
};

const {
  ACCOUNT,
  ANTIPIRACY,
  BROADCAST,
  CLASS,
  CTA_COMMUNITIES,
  COMMUNITY,
  CONFIG,
  DASHBOARD,
  DEFAULT,
  FREE_SIGNUP,
  TRACKS,
  LOGIN,
  MODULE,
  REPORTS,
  SALES,
  USER
} = ROUTE_NAMESPACES;

export const PAGE_TO_REDIRECT = 'hmRedirect';

export const MODULE_CONTENT = 'content';
export const MODULE_QUIZ = 'quiz';
export const MODULE_ADVERTISEMENT = 'advertisement';
export const MODULE_WEBINAR = 'webinar';
export const MODULE_LIVE = 'live';

export const BASE_ADVERTISEMENT = `/${MODULE_ADVERTISEMENT}`;
export const BASE_MODULE = MODULE;

const ROUTES = {
  DEFAULT,
  ACCOUNT,
  ANTIPIRACY,
  CTA_COMMUNITIES,
  BROADCAST: {
    LIST: `${BROADCAST}`,
    NEW: `${BROADCAST}/new`
  },
  CLASS: {
    LIST: `${CLASS}`,
    EDIT: `${CLASS}/:id`,
    NEW: `${CLASS}/new`
  },
  COMMUNITY: {
    LIST: COMMUNITY,
    HISTORY: `${COMMUNITY}/comments/:commentUserId`
  },
  CONFIG,
  CONTENT: {
    LIST: MODULE,
    IMPORT: `${MODULE}/import`,
    ADD_CONTENT: `${MODULE}/:moduleId/${MODULE_CONTENT}/new`,
    EDIT_ADVERTISEMENT: `${MODULE}/:moduleId/${MODULE_ADVERTISEMENT}/:pageId`,
    EDIT_CONTENT: `${MODULE}/:moduleId/${MODULE_CONTENT}/:id`,
    REVIEW_SUBTITLE: `${MODULE}/review-subtitle/:mediaId/:subtitleId`,
    EDIT_MODULE: `${MODULE}/:id`,
    EDIT_QUIZ: `${MODULE}/:moduleId/${MODULE_QUIZ}/:id`,
    NEW_ADVERTISEMENT: `${MODULE}/:moduleId/${MODULE_ADVERTISEMENT}/new`,
    NEW_MODULE: `${MODULE}/new`,
    NEW_EXTRA_PAID_MODULE: `${MODULE}/extra-paid/new`,
    EDIT_EXTRA_PAID_MODULE: `${MODULE}/extra-paid/:id`,
    NEW_QUIZ: `${MODULE}/:moduleId/${MODULE_QUIZ}/new`,
    NEW_WEBINAR: `${MODULE}/:moduleId/${MODULE_WEBINAR}/new`,
    NEW_LIVE_MF: `${MODULE}/:moduleId/${MODULE_LIVE}/new`,
    EDIT_WEBINAR: `${MODULE}/:moduleId/${MODULE_WEBINAR}/:id`,
    EDIT_LIVE_MF: `${MODULE}/:moduleId/${MODULE_LIVE}/:id`,
    TRACKS,
    NEW_TRACK: `${TRACKS}/new`,
    EDIT_TRACK: `${TRACKS}/:trackId/edit`,
    VIEW_TRACK: `${TRACKS}/:trackId`
  },
  FREE_SIGNUP,
  HEALTH_CHECK: '/public/healthCheck/version',
  LOGIN,
  REPORTS,
  SALES,
  USER: {
    LIST: USER,
    DETAIL: `${USER}/detail/:userId`,
    IMPORT: `${USER}/import`
  },
  DASHBOARD
};

const PAGE_VIEW_EVENTS = {
  ACCOUNT: 'Account',
  ANTIPIRACY: 'AntiPiracy',
  BROADCAST: {
    MAIN: 'Messages',
    NEW: 'MessageEditorAdd'
  },
  CLASS: {
    MAIN: 'Groups',
    EDIT: 'GroupEditorEdit',
    NEW: 'GroupEditorNew'
  },
  COMMUNITY: {
    MAIN: 'Comments',
    HISTORY: 'CommentDetail'
  },
  CONFIG: 'Settings',
  CTA_COMMUNITIES: 'CtaCommunities',
  CONTENT: {
    MAIN: 'Content',
    ADD_CONTENT: 'PageEditorAdd',
    EDIT_ADVERTISEMENT: 'AdEditorEdit',
    EDIT_CONTENT: 'PageEditorEdit',
    EDIT_MODULE: 'ModuleEditorEdit',
    EDIT_QUIZ: 'QuizEditorEdit',
    NEW_ADVERTISEMENT: 'AdEditorAdd',
    NEW_MODULE: 'ModuleEditorAdd',
    NEW_QUIZ: 'QuizEditorAdd',
    NEW_WEBINAR: 'LiveEditorNew',
    EDIT_WEBINAR: 'LiveEditorEdit',
    REVIEW_SUBTITLE: 'ReviewSubtitle',
    IMPORT_CONTENT: 'ImportContent'
  },
  REPORTS: 'Reports',
  SALES: 'Sales',
  USER: {
    MAIN: 'Users',
    DETAIL: 'UserDetail',
    IMPORT: 'UsersImport'
  },
  DASHBOARD: 'Home',
  TRACKS: {
    LIST: 'TrackList',
    NEW: 'TrackAdd',
    VIEW: 'TrackView',
    EDIT: 'TrackEdit'
  }
};

export { ROUTES, PAGE_VIEW_EVENTS };
